const map = {
  mainDepartmentList: () => import('@/views/basicData/DepartmentList'), // 部门列表
  mainDepartmentListDetail: () => import('@/views/basicData/DepartmentList/Detail'), // 部门详情
  mainDataCostCenter: () => import('@/views/basicData/MainDataCostCenter'), // 成本中心列表
  mainDataCostCenterDetail: () => import('@/views/basicData/MainDataCostCenter/Detail') // 成本中心详情
}

export default map
